/**
 * Created by abdulhafeth on 5/4/16.
 */
(function (angular, TeamAPI) {

    var events = {
        "search": []
    };

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    var onSearch = function (handler) {
        events["search"].push(handler);
    };

    var TeamService = ['TSUsersService', function (TSUsersService) {
        var self = this;
        var members = [];
        var originalMembers = [];
        var search = {};
        self.onSearch = onSearch;

        /**
         * Get team categories and positions
         * @returns {deferred.promise|{then, always}|{then}}
         */
        self.getPositionsAndCategories = function (brandId, isEmployee) {
            var deferred = $q.defer();
            if (!brandId) {
                throw "No brand id";
            }

            TeamAPI.getBrandActivePositionCategories(brandId, true, false, false, false, isEmployee)
                .then(function(result) {
                    var data = [];
                    for (var i in result.position_categories) {
                        var positionCategory = {
                            Position: result.position_categories[i].positions,
                            code: result.position_categories[i].code,
                            id: result.position_categories[i].id,
                            name: result.position_categories[i].name
                        };
                        data.push({PositionType: positionCategory});
                    }
                    deferred.resolve(data);

                }, function (error) {
                    console.error(error);
                    hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong while getting categories"));
                });

            return deferred.promise;
        };

        /**
         * in case a change is needed in the original members u can set it from here
         * @param members
         */
        self.setOriginalMembers = function (members) {
            originalMembers = members;
        };

        self.addOriginalMembers = function (member) {
            originalMembers.push(member);
        };

        /**
         * in case a change is needed in the  members u can set it from here
         * @param members
         */
        self.setMembers = function (mems) {
            members = mems;
        };

        /**
         * Sets the search object
         * @param searchObject
         */
        self.setSearch = function (searchObject) {
            search = searchObject;
        };

        /**
         * Get the team members for the selected brand
         */
        self.getTeamMembers = function (brandId, userStatus, schedulable) {
            var deferred = $q.defer();

            TSUsersService.loadBrandUsers(brandId, true, userStatus, schedulable)
                .then(function (members) {
                    var preparedMembers = getPreparedMembers(angular.copy(members))
                    originalMembers = angular.copy(preparedMembers);
                    self.doSearch();
                    deferred.resolve({members: preparedMembers, originalMembers: originalMembers});
                }, function (error) {
                    console.error(error);
                    hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong!"));
                });

            return deferred.promise;
        };

        var getPreparedMembers = function (members) {
            for (var index in members) {
                var member = members[index];
                member.name = member.display_name;
                member.first_name = '';
            }
            return members;
        }

        /**
         * Clears search filters and performs search
         * @returns {{searchTerm: undefined, search: {}}}
         */
        self.clearFilters = function () {
            var searchTerm = undefined;
            search = {category: undefined, position: undefined};
            self.doSearch();
            return {searchTerm: searchTerm, search: search};
        }

        /**
         * Search the team members according to their positions and categories
         * @param event
         */
        self.doSearch = function (event) {

            if (event) {
                if (event.currentTarget.name == "category_id") {
                    search.category = event.added.value;
                    search.position = undefined;
                } else {
                    search.position = event.added.value;
                }
            }

            members = angular.copy(originalMembers);
            var filteredMembers = [];
            if (!search.category && !search.position) {
                trigger("search", members);
                return;
            }

            var selectedCategory = search.category && search.category.PositionType.id;
            var selectedPosition = search.position && search.position.code;

            for (var index in members) {
                var member = members[index];
                for (var positionIndex in member.positions) {
                    var position = member.positions[positionIndex];

                    if (selectedPosition) {
                        if (position.code === selectedPosition) {
                            filteredMembers.push(member);
                            break;
                        }
                    }
                    else if (selectedCategory) {
                        if (selectedCategory == position.category.id) {
                            filteredMembers.push(member);
                            break;
                        }
                    }
                    else {
                        filteredMembers.push(member);
                        break;
                    }

                }
            }

            members = filteredMembers;
            trigger("search", members);
        };
    }];

    angular
        .module('harriApp')
        .service('TeamService', TeamService);

})(angular, TeamAPI);
